<template>
  
  <div>
    <div v-if="order !== undefined && order.invoices !== undefined && order.invoicesAllPaid !== null">
      <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" min-width="800">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" >
            <div>
              <!-- :color="overallinvoicedStatusColor" -->
              <v-icon 
                :size="8"
                :color="order.invoicedPercentageColor"
              >
                fas fa-square-full
              </v-icon>
            </div>
            <div>
              <!-- :color="overallPaymentStatusColor" -->
              <v-icon 
                :size="8"
                :color="order.paidPercentageColor"
              >
                fas fa-square-full
              </v-icon>
            </div>
            <!-- <div v-for="(invoiceKey, index) in Object.keys(order.invoices)" :key="'order-invoice-status-'+invoiceKey">
              <v-icon 
                :color="order.invoices[invoiceKey].status && settings.orderStatusColors[order.invoices[invoiceKey].status] ? settings.orderStatusColors[order.invoices[invoiceKey].status] : '#ccc'"
                :size="8"
                style="padding-right:2px;"
              >
                fas fa-square-full
              </v-icon>
            </div> -->
          </span>
        </template>
        
        <div style="font-size:11px;background:#FFF;" class="">
          <div class="py-1 text-center" style="background:#666;color:#FFF;font-size:12px;">
            YHTEENVETO
          </div>
          <v-row class="mx-4 pt-6" style="border-bottom:1px solid #ccc;">
              <v-col cols="2" class="pa-0"><b>Status</b></v-col>
              
              <v-col cols="2" class="px-2 py-0"><b>Koko tilaus</b></v-col>
              <v-col cols="2" class="px-2 py-0"><b>Maksamatta</b></v-col>
              <v-col cols="2" class="px-2 py-0"><b>Laskutettu €</b></v-col>
              <v-col cols="2" class="px-2 py-0"><b>Maksettu €</b></v-col>
              <v-col cols="2" class="pa-0"><b>Maksettu pvm</b></v-col>
          </v-row>
          <v-row class="mx-4 mb-6" style="font-size:10px;">
            <v-col cols="2" class="pa-0">
              <v-icon 
                :color="order.invoicesAllPaid ? '#2ECC40' : '#ff2f00'"
                :size="8"
                style="padding-right:2px;"
              >
                fas fa-square-full
              </v-icon>
              {{ order.invoicesAllPaid ? 'Maksettu' : 'Ei maksettu' }}
            </v-col>
            <!-- <v-col cols="2" class="px-2 py-0">{{ order.invoicesOrderInvoiceAmountWithVat +' ('+order.invoicesSumWithoutVat+'  + ALV '+order.invoicesVatPercentage+'%)' }}</v-col> -->
            <v-col cols="2" class="px-2 py-0">{{ order.invoicesOrderInvoiceAmountWithVat }}</v-col>
            <v-col cols="2" class="px-2 py-0">{{ order.invoicesSumNotPaidWithVat +' ('+order.invoicesSumNotPaidWithoutVat+'  + ALV '+order.invoicesVatPercentage+'%)' }}</v-col>
            <v-col cols="2" class="px-2 py-0">{{ order.invoicesSumWithVat +' ('+order.invoicesSumWithoutVat+'  + ALV '+order.invoicesVatPercentage+'%)' }}</v-col>
            <v-col cols="2" class="px-2 py-0">{{ order.invoicesPaidSumWithVat +' ('+order.invoicesPaidSumWithoutVat+'  + ALV '+order.invoicesVatPercentage+'%)' }}</v-col>
            <v-col cols="2" class="pa-0">{{order.invoicesPaidDate ? customFormatter(order.invoicesPaidDate) : ''}}</v-col>
          </v-row>
          
          <div class="py-1 text-center" style="background:#666;color:#FFF;font-size:12px;">
            LASKUT
          </div>
          <div class="pb-4 pt-8">
            <v-row class="mx-4">
              <v-col cols="1" class="pa-0"><b>Status</b></v-col>
              <v-col cols="2" class="pa-0"><b>Laskun pvm</b></v-col>
              <v-col cols="1" class="pa-0"><b>Lask #</b></v-col>
              <!-- <v-col cols="1" class="pa-0"><b>Linkki</b></v-col> -->
              <v-col cols="2" class="pa-0"><b>Eräpäivä</b></v-col>
              <v-col cols="2" class="px-2 py-0"><b>Laskutettu €</b></v-col>
              <v-col cols="2" class="px-2 py-0"><b>Maksettu €</b></v-col>
              
              <v-col cols="2" class="pa-0"><b>Maksettu pvm</b></v-col>
            </v-row>
            <v-row v-for="(invoiceKey, index) in Object.keys(order.invoices)" :key="'order-invoice-status-'+invoiceKey" style="font-size:10px;border-top:1px solid #ccc;" class="mx-4 mb-1">
              <v-col cols="1" class="pa-0">
                <v-icon 
                  :color="order.invoices[invoiceKey].status && settings.orderStatusColors[order.invoices[invoiceKey].status]? settings.orderStatusColors[order.invoices[invoiceKey].status] : '#ccc'"
                  :size="8"
                  style="padding-right:2px;"
                >
                  fas fa-square-full
                </v-icon>
                {{settings.invoiceStatusObject[order.invoices[invoiceKey].status] ? settings.invoiceStatusObject[order.invoices[invoiceKey].status].text : order.invoices[invoiceKey].status}}
              </v-col>
              <v-col cols="2" class="pa-0">
                {{order.invoices[invoiceKey].invoiceDate ? customFormatter(order.invoices[invoiceKey].invoiceDate) : ''}}
              </v-col>
              <!-- <v-col cols="1" class="pa-0">
                {{ order.invoices[invoiceKey].invoiceNumber }}
              </v-col> -->
              <v-col cols="1" class="pa-0">
                <a class="pointer" v-if="order.netvisorKey && invoiceKey" :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+invoiceKey" target="_blank">{{order.invoices[invoiceKey].invoiceNumber}}</a>
                <a v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' && order.netvisorKey_test_env && invoiceKey" class="pointer pl-1" :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+invoiceKey" target="_blank">{{order.invoices[invoiceKey].invoiceNumber}}</a>
              </v-col>
              <v-col cols="2" class="pa-0">
                {{order.invoices[invoiceKey].dueDate ? customFormatter(order.invoices[invoiceKey].dueDate) : ''}}
              </v-col>
              <v-col cols="2" class="px-2 py-0">
                {{ order.invoices[invoiceKey].sumWithVat + ' ('+order.invoices[invoiceKey].sumWithoutVat+' + ALV '+order.invoices[invoiceKey].vatPercentage + '%)'}}
              </v-col>
              <v-col cols="2" class="px-2 py-0">
                {{ order.invoices[invoiceKey].paidSumWithVat + ' ('+order.invoices[invoiceKey].paidSumWithoutVat+' +VAT '+order.invoices[invoiceKey].vatPercentage + '%)'}}
                <span class="pl-1"></span>
              </v-col>
              <v-col cols="2" class="pa-0">
                {{order.invoices[invoiceKey].paidDate ? customFormatter(order.invoices[invoiceKey].paidDate) : ''}}
              </v-col>
              <v-col cols="3" v-if="order.invoices[invoiceKey].payments" class="mt-1" style="border-top:1px dotted #ccc;border-left:1px dotted #ccc;border-bottom:1px dotted #ccc;background:#eee;">
                <div style="display:flex;justify-content:center;align-items:center;height:100%;font-weight:600"><span>Suoritukset</span></div>
              </v-col>
              <v-col cols="9" v-if="order.invoices[invoiceKey].payments" class="mt-1 " style="border:1px dotted #ccc;background:#fafafa">
                <v-row class="pl-2" style="border-bottom:1px solid #eee;">
                  <v-col cols="2" class="pa-0"><b>Linkki</b></v-col>
                  <v-col cols="2" class="pa-0"><b>Suoritus lähde</b></v-col>
                  <v-col cols="3" class="pa-0"></v-col>
                  
                  <v-col cols="2" class="pa-0"><b>Maksettu €</b></v-col>
                  <v-col cols="3" class="pa-0"><b>Suoritus pvm</b></v-col>
                  
                  
                </v-row>
                <v-row v-for="(paymentKey, index) in Object.keys(order.invoices[invoiceKey].payments)" :key="'order-invoice-payment-status-'+paymentKey" style="font-size:10px;" class="pl-2">
                  <v-col cols="2" class="pa-0">
                    <a v-if="order.netvisorKey" class="pointer" :href="'https://suomi.netvisor.fi/evo/accounting/voucher/voucher.aspx?id='+order.invoices[invoiceKey].payments[paymentKey].voucherId" target="_blank">link</a>
                    <a v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' && order.netvisorKey_test_env" class="pointer pl-1" :href="'https://koulutus.netvisor.fi/evo/accounting/voucher/voucher.aspx?id='+order.invoices[invoiceKey].payments[paymentKey].voucherId" target="_blank">link</a>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <span v-if="order.invoices[invoiceKey].payments[paymentKey].paymentSource === '1'">Viitesuoritus</span>
                    <span v-else-if="order.invoices[invoiceKey].payments[paymentKey].paymentSource === '2'">Hyvityslasku</span>
                    <span v-else-if="order.invoices[invoiceKey].payments[paymentKey].paymentSource === '3'">Rahoituspalvelu</span>
                    <span v-else-if="order.invoices[invoiceKey].payments[paymentKey].paymentSource === '99'">Muu</span>
                  </v-col>
                  <v-col cols="3" class="pa-0"></v-col>
                  <v-col cols="2" class="pa-0">
                    {{ order.invoices[invoiceKey].payments[paymentKey].sumWithVat + ' ('+order.invoices[invoiceKey].payments[paymentKey].sumWithoutVat+'+ ALV '+order.invoices[invoiceKey].vatPercentage+'%)' }}
                  </v-col>
                  <v-col cols="3" class="pa-0">
                    {{order.invoices[invoiceKey].payments[paymentKey].paymentDate ? customFormatter(order.invoices[invoiceKey].payments[paymentKey].paymentDate) : ''}}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-menu>
    </div>
    <div >
      <v-menu v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" min-width="400" >
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" >
            <div>
              <v-icon 
                :size="8"
                color="#000"
                @click="syncInvoiceStatusesForOrder(order.id)"
              >
                fas fa-exchange-alt
              </v-icon>
            </div>
          </span>
        </template>
        
        <div style="font-size:11px;background:#FFF;" class="">
          <div class="py-5 text-center" style="font-size:12px;">
            Synkronoi laskutustiedot netvisorista.
          </div>
        </div>
      </v-menu>
      <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" min-width="400">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" >
            <div>
              <v-icon 
                :size="8"
                color="blue"
                @click="syncInvoiceStatusesForOrderDirect(order.id)"
              >
                fas fa-exchange-alt
              </v-icon>
            </div>
          </span>
        </template>
        
        <div style="font-size:11px;background:#FFF;" class="">
          <div class="py-5 text-center" style="font-size:12px;">
            Synkronoi laskutustiedot netvisorista.
          </div>
        </div>
      </v-menu>
    </div>
    
    
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import axios from 'axios'

export default {
    props: ['order'],
    data: () => ({
        
      
    }),
    mounted() {
    },
    computed: {
      ...mapFields([
        'settings.isAuthenticated',
        'settings.isSales',
        'settings.isOffice',
        'selectedView.officeView',
        'selectedView.salesView',
        'selectedView.clientView',
        'settings',
        'user',
        
      ]),
      overallPaymentStatusColor(){
        var color = "ff2f00"
        this.order.invoicesAllPaid ? color = '#2ECC40' : ''
        this.order.invoicesSumNotPaidWithVat > 0 && this.order.invoicesPaidSumWithVat > 0 ? color = '#ff982e' : ''
        return color
      },
      overallinvoicedStatusColor(){
        var color = "ff2f00"
        this.order.invoicesAllPaid ? color = '#2ECC40' : ''
        this.order.invoicesSumNotPaidWithVat > 0 && this.order.invoicesPaidSumWithVat > 0 ? color = '#ff982e' : ''
        return color
      }
    },
    created () {},
    methods: {
      async syncInvoiceStatusesForOrder(orderId){
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Päivitetään Netvisor laskujen tietoja järjestelmään...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        console.log(orderId)
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/netvisorSyncInvoiceStatusesForOrderFunction': 'https://us-central1-avecor-709ff.cloudfunctions.net/netvisorSyncInvoiceStatusesForOrderFunction'
          let res = await axios.post(url,
            { orderId },
          );
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      async syncInvoiceStatusesForOrderDirect(orderId){
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Päivitetään Netvisor laskujen tietoja järjestelmään...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        console.log(orderId)
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/netvisorSyncInvoiceViaSystemStatusesForOrderFunction': 'https://us-central1-avecor-709ff.cloudfunctions.net/netvisorSyncInvoiceViaSystemStatusesForOrderFunction'
          let res = await axios.post(url,
            { orderId },
          );
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      customFormatter(date,includetime) {
        try{
          if (date.seconds) {
            var myDate = new Date(date.seconds*1000);
            if(includetime) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
            return dateFormat(myDate, "yyyy-mm-dd")
          }
          if (date._seconds) {
            var myDate = new Date(date._seconds*1000);
            if(includetime) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
            return dateFormat(myDate, "yyyy-mm-dd")
          }
          else if (date !== undefined && date.seconds === undefined){
            if(includetime) return dateFormat(date, "yyyy-mm-dd HH:MM")
            return dateFormat(date, "yyyy-mm-dd")
          }
          return ''
        }
        catch(e){
          return ''
        }
      },
      
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/PaymentStatus.vue